import {BaseService} from "./base-service";
import {Injectable} from "@angular/core";
import {Settings} from "../settings/base";
import {Http} from "@angular/http";
/**
 * Created by kennethmwangi on 22/04/2017.
 */



@Injectable()
export class PaymentMethodService extends BaseService {
    
  
  constructor(private http: Http, private _settings: Settings) {

    super();
  }

  getPaymentMethods() {

    return this.http.get(this._settings.base_url+ "payment_methods/", this.createHeaders("Authorization"))
      .map(res => res.json());
  }

  getPaymentMethod(id) {
    return this.http.get(this.getPaymentMethodUrl(id), this.createHeaders("Authorization"))
      .map(res => res.json());
  }


  private getPaymentMethodUrl(id) {
    return this._settings.base_url+ "payment_methods/" + id;

  }

}



// WEBPACK FOOTER //
// ./src/providers/payment-service.ts